'use es6';

import { AxisTypes, Layer } from 'reporting-visualizations/visualizations/xy/xyRecords';
import { CUSTOM_SERIES_DATASET_PREFIX } from 'reporting-data/customSeries/resolveV2CustomSeries';
import { BATTLESHIP } from 'reporting-visualizations/constants/hubStyleTokensColors';
export const applyCustomSeries = visualization => {
  const customSeriesLayers = visualization.get('data').filter((v, k) => k.includes(CUSTOM_SERIES_DATASET_PREFIX)).map((dataset, datasetKey) => {
    return Layer({
      dataset: datasetKey,
      mark: {
        dashStyle: 'ShortDash',
        type: 'line'
      },
      x: {
        type: AxisTypes.category,
        field: 'date',
        blend: 'bottom'
      },
      y: {
        type: AxisTypes.linear,
        field: 'value',
        blend: 'left'
      },
      color: {
        default: BATTLESHIP
      }
    });
  });
  return visualization.update('layers', layers => customSeriesLayers.toList().concat(layers));
};